import TikTokIcon from "@/components/ui/OpticksIcons/TikTokIcon";
import { routesMap } from "@/components/routes/routes";
import ChannelIntegrationGuide from "@/components/channel-integration-guide/ChannelIntegrationGuide";
import type { ChannelIntegrationConfig } from "@/components/channel-integration-guide/ChannelIntegrationGuide.types";
import TikTokIntegrationStep2 from "./steps/components/TikTokIntegrationStep2";
import TikTokIntegrationStep3 from "./steps/components/TikTokIntegrationStep3";
import { userIsDemo } from "@/utilities/planHelpers";
import { useUsersStore } from "@/zustand/usersStore";
import TikTokIntegrationStep1 from "./steps/components/TikTokIntegrationStep1";

const tiktokConfig: ChannelIntegrationConfig = {
  channelName: "TikTok Ads",
  channelDisplayName: "TikTok",
  platformKey: "tiktok",
  oauthPlatformKey: "tiktok",
  icon: <TikTokIcon size={32} />,
  supportsOAuth: true,
  overviewPath: routesMap.integration.tiktok.overview.path,
  linkingPath: routesMap.integration.tiktok.linking.path,
  pixelManagementPath: routesMap.integration.channelsCenter.path + "?channel=tiktok",
  guideSteps: [
    {
      content: (stepLabel) => <TikTokIntegrationStep1 stepLabel={stepLabel} />,
      manualOnly: true,
    },
    {
      content: (stepLabel) => <TikTokIntegrationStep2 stepLabel={stepLabel} />,
      manualOnly: false,
    },
    {
      content: (stepLabel) => <TikTokIntegrationStep3 stepLabel={stepLabel} />,
    },
  ],
};

const TikTokIntegration = () => {
  const user = useUsersStore((state) => state.user);
  const isDemo = userIsDemo(user);

  return (
    <ChannelIntegrationGuide config={tiktokConfig} isOAuthAvailable={!isDemo} />
  );
};

export default TikTokIntegration;
